import clsx from "clsx";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Image from "next/image";
import bgOnstepWhat from "/public/onstep/bg-onstepWhat.webp";
import bgOnstepWhatSp from "/public/onstep/bg-onstepWhatSp.webp";
import leadAbout from "/public/onstep/lead-about.svg";
import { Br } from "../molecules/Br";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

// SVGパスデータを別オブジェクトとして定義
const svgPaths = {
  topGroup: [
    {
      id: "top-shape-1",
      path: "M242.132 108.589C241.587 106.297 240.539 104.013 238.984 102.222C237.858 100.917 236.404 100.048 234.783 99.2983C230.336 97.2409 221.016 98.8186 225.301 114.761C225.819 116.749 226.035 118.816 226.008 120.855C225.977 123.241 224.431 126.084 221.765 124.994C219.649 124.127 218.704 121.799 218.551 119.669C218.193 114.893 218.794 110.332 217.263 105.692C216.23 102.578 211.929 95.7578 201.815 96.3613C194.544 96.748 187.473 101.934 185.533 109.218C184.331 113.705 184.399 118.717 184.64 123.41C184.847 127.39 185.249 130.504 186.097 134.472C186.475 136.252 186.896 138.053 187.421 139.809C187.856 141.284 188.515 142.859 189.739 143.795C191.784 145.368 195.056 145.701 197.29 144.959C204.526 142.534 200.211 132.613 199.428 128.097C198.995 125.603 198.433 122.355 199.061 119.896C199.64 117.585 201.786 116.592 203.804 117.892C205.451 118.957 205.91 122.301 206.026 124.117C206.129 125.776 206.164 126.553 206.194 128.213C206.26 131.943 206.543 135.448 208.7 138.679C213.836 146.358 226.084 148.219 233.333 144.165C237.576 141.791 240.124 136.861 241.426 132.089C242.728 127.316 243.769 115.581 242.143 108.599L242.132 108.589Z",
    },
    {
      id: "top-shape-2",
      path: "M181.251 49.6108C183.204 40.7184 193.558 21.7096 215.49 24.7509C215.49 24.7509 229.61 26.7589 238.454 41.0264C246.964 54.7321 248.891 75.7278 248.891 75.7278C250.379 87.9769 242.248 94.379 235.388 93.7079C228.529 93.0367 222.218 87.2278 223.762 78.3634C225.878 66.2314 223.299 60.569 221.608 58.1808C216.426 50.8603 208.122 52.8411 204.828 58.3725C202.87 61.6637 202.204 70.8914 203.432 78.5526C203.87 92.5536 181.048 93.7732 179.437 79.3823C178.726 73.047 179.822 56.0982 181.24 49.6215L181.251 49.6108Z",
    },
    {
      id: "top-shape-3",
      path: "M214.808 180.947C211.846 180.903 209.125 179.1 207.818 176.495C206.479 173.828 206.583 166.68 208.077 160.875C209.367 150.133 191.287 147.531 189.034 158.478C188.038 163.297 187.767 176.417 188.456 181.502C189.41 188.485 196.363 203.867 214.026 203.124L215.696 203.117C233.363 203.782 240.231 188.364 241.136 181.381C241.802 176.294 241.443 163.174 240.423 158.358C238.107 147.426 220.037 150.109 221.404 160.836C222.935 166.632 223.073 173.776 221.755 176.457C220.589 178.821 218.267 180.531 215.637 180.881L214.787 180.948L214.808 180.947Z",
    },
  ],
  middleLeftGroup: [
    {
      id: "middle-left-1",
      path: "M121.683 34.2862C118.157 26.5801 104.981 11.2724 85.6756 18.1907C85.6756 18.1907 73.2589 22.6843 68.0532 37.3072C63.0451 51.3621 65.457 70.7919 65.457 70.7919C66.5302 82.1947 75.1842 86.4771 81.2769 84.5696C87.3696 82.6621 91.9472 76.1941 88.7925 68.4387C84.4657 57.8234 85.6823 52.1915 86.7521 49.706C90.007 42.0844 97.9367 42.3095 102.023 46.7079C104.448 49.324 106.877 57.5748 107.283 64.7638C109.658 77.5654 130.616 74.3548 129.228 60.9841C128.613 55.1009 124.264 39.9156 121.695 34.2948L121.683 34.2862Z",
    },
    {
      id: "middle-left-2",
      path: "M124.459 161.498C121.714 162.182 118.919 161.098 117.139 159.051C115.317 156.947 113.752 150.492 113.75 144.93C112.429 134.976 94.9324 136.83 95.4176 147.192C95.6297 151.763 97.5765 163.845 99.4444 168.254C102.774 176.107 110.366 184.955 128.927 181.753C146.957 178.646 149.828 162.307 149.045 155.81C148.479 151.075 144.313 139.551 142.275 135.443C137.653 126.115 122.024 132.567 125.737 141.925C128.452 146.797 130.24 153.206 129.67 155.906C129.172 158.288 127.194 160.815 124.449 161.5L124.459 161.498Z",
    },
    {
      id: "middle-left-3",
      path: "M84.3763 110.554C81.9671 95.8865 90.9309 83.8013 105.717 81.4175C120.535 79.0287 132.913 87.6838 135.322 102.351C137.707 116.875 128.708 128.882 113.879 131.262C99.0822 133.648 86.7507 125.08 84.366 110.556L84.3763 110.554ZM120.586 104.601C119.553 98.3013 114.361 94.5753 108.073 95.5889C101.786 96.6025 98.0591 101.766 99.0924 108.066C100.122 114.345 105.309 118.04 111.596 117.027C117.884 116.013 121.616 110.88 120.588 104.611L120.586 104.601Z",
    },
  ],
  middleGroup: [
    {
      id: "middle-1",
      path: "M134.626 233.971C131.17 226.238 118.128 210.841 98.7569 217.653C98.7569 217.653 86.2976 222.078 80.9597 236.684C75.8246 250.722 78.0627 270.183 78.0627 270.183C79.0338 281.601 87.6509 285.938 93.7619 284.064C99.8728 282.19 104.509 275.743 101.424 267.963C97.1912 257.313 98.4587 251.683 99.551 249.202C102.875 241.593 110.804 241.864 114.852 246.29C117.253 248.922 119.609 257.194 119.951 264.392C122.211 277.218 143.202 274.127 141.934 260.736C141.372 254.844 137.158 239.621 134.638 233.98L134.626 233.971Z",
    },
    {
      id: "middle-2",
      path: "M136.252 361.311C133.5 361.98 130.714 360.878 128.952 358.819C127.149 356.703 125.642 350.233 125.689 344.667C124.458 334.697 106.941 336.45 107.333 346.824C107.504 351.4 109.343 363.504 111.172 367.928C114.431 375.807 121.945 384.707 140.538 381.61C158.6 378.605 161.619 362.269 160.894 355.761C160.37 351.019 156.306 339.46 154.305 335.336C149.765 325.974 134.076 332.341 137.705 341.729C140.377 346.621 142.108 353.046 141.514 355.744C140.994 358.126 138.993 360.644 136.241 361.313L136.252 361.311Z",
    },
    {
      id: "middle-3",
      path: "M137.112 301.069C133.875 299.576 129.486 298.639 124.056 298.284C121.485 298.116 119.728 297.853 118.68 297.48C116.961 296.864 116.356 295.718 116.145 294.868C115.922 293.946 116.1 293.026 116.651 292.205C117.212 291.382 118.028 290.835 119.023 290.617C120.271 290.339 121.991 290.703 124.428 291.732C127.465 293.026 130.015 293.45 132.005 293.014C133.772 292.625 135.054 291.774 135.929 290.419C136.821 289.041 137.037 287.515 136.615 285.752C136.293 284.404 135.551 283.196 134.37 282.065C133.164 280.918 131.68 280.056 129.947 279.484C126.064 278.227 121.733 278.101 117.084 279.128C111.661 280.317 107.411 282.648 104.459 286.048C101.066 289.97 100.028 294.418 101.294 299.654C102.957 306.5 107.85 310.238 116.248 311.067C124.785 311.916 125.455 312.159 125.822 312.28C127.767 312.998 128.432 314.25 128.655 315.172C128.902 316.184 128.754 317.153 128.234 317.969C127.698 318.819 126.855 319.392 125.789 319.631C124.815 319.845 123.834 319.829 122.898 319.565C122.403 319.432 121.36 319.089 117.99 317.626C115.538 316.568 113.381 316.23 111.594 316.623C109.637 317.074 108.139 318.021 107.025 319.518C105.874 321.116 105.532 322.84 106.005 324.794C106.721 327.731 108.802 329.94 112.395 331.547C117.033 333.643 122.54 334.017 128.764 332.651C135.486 331.176 140.26 328.375 142.954 324.353C145.579 320.425 146.292 316.184 145.128 311.384C144.581 309.104 143.559 307.004 142.101 305.139C140.669 303.302 138.987 301.934 137.112 301.069Z",
    },
  ],
  middleRightGroup: [
    {
      id: "middle-right-1",
      path: "M188.1 254.971C190.822 246.281 202.797 228.242 224.381 233.178C224.381 233.178 238.273 236.405 245.84 251.388C253.121 265.782 253.209 286.867 253.209 286.867C253.622 299.2 244.962 304.872 238.187 303.607C231.411 302.343 225.631 296.007 227.943 287.31C231.111 275.407 229.035 269.541 227.559 267.015C223.035 259.272 214.589 260.524 210.824 265.748C208.586 268.857 207.117 277.993 207.672 285.732C206.886 299.719 184.043 298.951 183.694 284.474C183.539 278.1 186.11 261.31 188.088 254.98L188.1 254.971Z",
    },
    {
      id: "middle-right-2",
      path: "M210.069 388.734C207.121 388.433 204.568 386.4 203.493 383.692C202.419 380.983 203.12 373.805 205.114 368.151C207.337 357.562 189.552 353.398 186.352 364.109C184.939 368.824 183.523 381.871 183.766 386.997C184.107 394.037 189.691 409.966 207.353 410.761L209.018 410.899C226.561 413.097 234.749 398.332 236.261 391.454C237.368 386.444 238.156 373.342 237.56 368.454C236.207 357.362 217.97 358.465 218.395 369.271C219.415 375.179 218.928 382.308 217.381 384.865C216.014 387.118 213.551 388.62 210.9 388.74L210.048 388.733L210.069 388.734Z",
    },
    {
      id: "middle-right-3",
      path: "M236.485 308.997C235.619 308.578 234.828 308.291 234.123 308.147C233.583 308.035 232.041 307.812 227.767 307.354L208.09 305.249C204.234 304.842 201.744 304.615 200.693 304.594C199.768 304.571 198.875 304.698 198.037 304.945C196.78 305.31 195.719 306.026 194.757 307.149C193.782 308.292 193.225 309.485 193.068 310.823C192.84 312.735 193.392 314.48 194.77 316.167C195.954 317.609 197.998 318.489 200.829 318.793L207.465 319.5L204.124 345.823C203.907 347.567 203.856 348.901 203.973 349.794C204.073 350.623 204.382 351.477 204.869 352.343C206.221 354.692 208.331 355.988 211.309 356.302C214.329 356.629 216.677 355.719 218.482 353.539C219.651 352.167 220.395 350.102 220.731 347.397L224.048 321.283L229.941 321.917C233.034 322.25 235.276 321.943 236.616 321.005C238.628 319.629 239.726 317.915 239.992 315.764C240.16 314.406 239.903 313.113 239.214 311.822C238.535 310.542 237.641 309.626 236.484 309.008L236.485 308.997Z",
    },
  ],
  bottomLeftGroup: [
    {
      id: "bottom-left",
      path: "M132.889 428.727C129.847 420.821 117.638 404.763 97.9267 410.57C97.9267 410.57 85.246 414.349 79.1382 428.668C73.263 442.43 74.4648 461.991 74.4648 461.991C74.8283 473.452 83.2055 478.229 89.4092 476.672C95.6129 475.115 100.587 468.912 97.9178 460.979C94.2559 450.119 95.8207 444.559 97.0437 442.136C100.768 434.704 108.674 435.384 112.482 440.016C114.741 442.77 116.655 451.157 116.614 458.367C118.19 471.3 139.322 469.294 138.767 455.848C138.518 449.932 135.118 434.503 132.901 428.736L132.889 428.727Z",
    },
    {
      id: "bottom-center",
      path: "M127.758 556.051C124.974 556.578 122.251 555.333 120.6 553.185C118.911 550.977 117.749 544.434 118.092 538.875C117.392 528.849 99.8013 529.697 99.6421 540.083C99.5699 544.665 100.763 556.854 102.355 561.369C105.192 569.41 112.225 578.691 130.962 576.555C149.163 574.485 153.046 558.317 152.668 551.777C152.397 547.011 148.952 535.252 147.172 531.028C143.135 521.439 127.125 526.991 130.251 536.559C132.66 541.585 134.048 548.094 133.311 550.76C132.665 553.113 130.532 555.526 127.748 556.052L127.758 556.051Z",
    },
    {
      id: "bottom-right",
      path: "M124.118 486.918C126.924 486.504 128.913 485.673 130.025 484.452C131.485 482.871 132.007 481.021 131.632 478.794C131.266 476.649 130.065 475.091 127.958 474.044C126.944 473.553 125.996 473.285 125.128 473.27C124.437 473.257 122.715 473.372 118.46 474.008L107.46 475.64C103.421 476.244 101.617 476.763 100.816 477.086C99.7857 477.505 98.8662 478.279 98.0647 479.374C97.3624 480.323 96.964 481.283 96.8756 482.211C96.7799 483.266 96.9487 485.128 97.3842 487.725L102.146 515.932C102.719 519.33 103.475 521.696 104.375 522.982C105.2 524.15 106.579 524.927 108.588 525.357C109.326 525.511 110.063 525.571 110.802 525.548C111.603 525.517 113.056 525.337 115.123 525.03L129.484 522.895C131.457 522.598 132.905 522.272 133.796 521.909C134.596 521.586 135.334 521.061 135.971 520.38C137.421 518.81 137.957 516.99 137.591 514.845C137.225 512.701 136.144 511.193 134.233 510.126C133.332 509.613 132.4 509.302 131.482 509.208C130.468 509.103 129.026 509.189 127.165 509.464L117.337 510.924L116.241 504.416L124.26 503.226C126.439 502.897 127.974 502.311 128.822 501.461C129.984 500.319 130.402 498.96 130.129 497.286C129.855 495.612 129.02 494.549 127.572 493.8C126.414 493.23 124.945 493.067 123.218 493.329L114.583 494.613L113.549 488.485L124.107 486.919L124.118 486.918Z",
    },
  ],
  bottomRightGroup: [
    {
      id: "bottom-left-2",
      path: "M190.984 465.634C195.147 457.536 210.022 441.8 230.453 450.33C230.453 450.33 243.593 455.87 248.497 471.917C253.221 487.334 249.715 508.121 249.715 508.121C248.021 520.342 238.521 524.458 232.059 522.061C225.597 519.663 220.98 512.44 224.741 504.264C229.89 493.076 228.844 486.945 227.819 484.205C224.68 475.808 216.143 475.606 211.543 480.113C208.808 482.796 205.804 491.546 205.032 499.265C201.875 512.911 179.493 508.273 181.616 493.951C182.549 487.646 187.944 471.541 190.972 465.642L190.984 465.634Z",
    },
    {
      id: "bottom-center-2",
      path: "M189.845 601.147C186.991 600.349 184.821 597.913 184.224 595.062C183.611 592.142 185.54 585.259 188.469 580.027C192.464 569.973 175.646 562.849 170.668 572.857C168.472 577.262 164.854 589.875 164.22 594.966C163.356 601.959 166.146 618.601 183.416 622.385L185.033 622.804C201.948 627.95 212.533 614.796 215.194 608.277C217.139 603.529 220.147 590.755 220.393 585.839C220.949 574.681 202.789 572.669 201.367 583.387C201.365 589.38 199.671 596.321 197.711 598.577C195.979 600.564 193.296 601.626 190.663 601.294L189.825 601.142L189.845 601.147Z",
    },
    {
      id: "bottom-right-2",
      path: "M227.003 532.211C225.743 528.581 223.369 525.564 219.946 523.253C218.123 522.005 214.925 520.625 210.441 519.157L203.085 516.746C200.417 515.896 198.155 515.904 196.187 516.784C195.168 517.28 194.357 517.892 193.813 518.57C193.235 519.294 192.656 520.504 192.085 522.17L182.156 550.966C181.131 553.949 180.823 555.248 180.736 555.821C180.629 556.563 180.727 557.485 181.007 558.549C181.348 559.715 181.968 560.754 182.891 561.705C183.797 562.642 184.857 563.302 186.12 563.709C188.112 564.361 190.016 564.265 191.946 563.408C193.917 562.518 195.4 560.664 196.347 557.911L198.424 551.876L202.707 553.284C209.573 555.531 215.465 554.879 220.734 551.26C223.785 549.142 225.928 546.358 227.087 543.007C228.303 539.465 228.286 535.837 227.021 532.227L227.003 532.211ZM209.624 540.798L209.603 540.793C208.575 541.017 207.196 540.819 205.263 540.193C205.102 540.143 204.686 539.987 204.01 539.745L202.75 539.285L205.422 531.534L206.712 531.916C207.47 532.134 208.033 532.305 208.403 532.428C209.995 532.949 211.177 533.683 211.922 534.612C212.764 535.673 212.986 536.885 212.55 538.13C211.923 539.935 210.606 540.585 209.611 540.806L209.624 540.798Z",
    },
  ],
};

// アニメーション順序を制御する配列
const animationOrder = [
  { groupKey: "bottomRightGroup", custom: 5 },
  { groupKey: "bottomLeftGroup", custom: 4 },
  { groupKey: "middleRightGroup", custom: 3 },
  { groupKey: "middleGroup", custom: 2 },
  { groupKey: "topGroup", custom: 0 },
  { groupKey: "middleLeftGroup", custom: 1 },
];

export const OnstepWhat = ({ id, className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  // より複雑なアニメーション設定
  const advancedGroupVariants = {
    hidden: (custom) => ({
      opacity: 0,
      x: custom % 2 === 0 ? -40 : 40,
      y: 20,
    }),
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        duration: 0.25,
        ease: "easeIn",
      },
    },
  };

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        delayChildren: 0.1, // 最初の要素の遅延
        staggerChildren: 0.35, // 要素間の間隔
      },
    },
  };

  return (
    <Container
      id={id}
      className={clsx(
        className,
        " min-h-auto relative mx-auto flex items-start justify-start overflow-hidden py-20 lg:py-40"
      )}
    >
      <Inner className="relative z-10 flex w-full flex-col items-start justify-start gap-8 px-10 font-bold text-white xl:px-0">
        <div className="flex flex-col gap-6 md:gap-14">
          <h2 className="text-base leading-none tracking-widest">
            What is ONSTEP
          </h2>
          <div className="flex flex-col items-start">
            <h3 className="aspect-[520/120] h-auto w-full text-xl font-bold md:w-[520px]">
              <Image
                src={leadAbout}
                alt="ONSTEPの背景画像"
                quality={80}
                fill
                className="object-cover"
                priority={false}
              />
            </h3>
          </div>
        </div>
        <p className="w-full shrink font-bold leading-loose fluid-text-[14px,16px]">
          ONSTEPは、ファンマーケティングの全機能を統合したプラットフォーム。
          <Br pc />
          会員管理からEC、コンテンツ配信まで一括提供、複数テナント対応で手数料率も自由設定。
          <Br pc />
          運営業務を簡素化し、ファンとの絆を深めながら収益向上を実現。
          <Br pc />
          多言語対応で国内外のコミュニティ構築をサポートします。
        </p>
        <div className="absolute -top-[80px] right-0 hidden xl:block">
          <motion.svg
            ref={ref}
            viewBox="0 0 294 635"
            className={clsx(
              "fill-current aspect-[294/635] h-auto w-[240px]",
              className
            )}
            fill="none"
            aria-label="装飾的なイラスト"
            role="img"
            animate={isInView ? "visible" : "hidden"}
            variants={containerVariants}
          >
            {animationOrder.map(({ groupKey, custom }) => (
              <motion.g
                key={groupKey}
                custom={custom}
                variants={advancedGroupVariants}
              >
                {svgPaths[groupKey].map(({ id, path }) => (
                  <path key={id} id={id} d={path} fill="white" />
                ))}
              </motion.g>
            ))}
          </motion.svg>
        </div>
      </Inner>
      <div className="absolute inset-0 z-0 hidden h-full w-full xl:block">
        <Image
          src={bgOnstepWhat}
          alt="ONSTEPの背景画像"
          quality={80}
          fill
          className="object-cover"
          priority={false}
        />
      </div>
      <div className="absolute inset-0 z-0 block aspect-[768/872] h-full w-full xl:hidden">
        <Image
          src={bgOnstepWhatSp}
          alt="ONSTEPの背景画像"
          quality={80}
          fill
          className="object-cover"
          priority={false}
        />
      </div>
    </Container>
  );
};

export default OnstepWhat;
